var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChat = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 19.667c-1.067 0-2.133-.2-3.067-.534L5.667 21v-3.733C4 15.733 3 13.667 3 11.333 3 6.733 7 3 12 3s9 3.733 9 8.333-4 8.334-9 8.334m-3.333-9.334c-.534 0-1 .467-1 1 0 .534.466 1 1 1 .533 0 1-.466 1-1 0-.533-.467-1-1-1m3.333 0c-.533 0-1 .467-1 1 0 .534.467 1 1 1s1-.466 1-1c0-.533-.467-1-1-1m3.333 0c-.533 0-1 .467-1 1 0 .534.467 1 1 1 .534 0 1-.466 1-1 0-.533-.466-1-1-1",
  clipRule: "evenodd"
})));
export default SvgChat;